function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;

import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { html, css, LitElement } from "lit";
import { property, state, customElement } from "lit/decorators.js";
import { defineCustomElement } from "@justifi/webcomponents/dist/components/justifi-card-form.js";
import { parseJwt, apiHost } from "../lib/utils.js";
import "./loading-animation.js";
import { when } from "lit/directives/when.js";
import { classMap } from "lit/directives/class-map.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;

var __decorateClass = function __decorateClass(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;

  for (var i = decorators.length - 1, decorator; i >= 0; i--) {
    if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  }

  if (kind && result) __defProp(target, key, result);
  return result;
};

defineCustomElement();
var paymentProcessorClientId = {
  live: "live_qrutPmwY10YbjFInxwPh6GQgGagneeDq",
  test: "test_hh3GX6nxz0NHWI8xQRoAcFo8xDIM9qZP"
};

function cardSvg(cardBrand) {
  switch (cardBrand) {
    case "visa":
      return visa;

    case "mastercard":
      return mastercard;

    case "amex":
      return amex;

    default:
      return defaultCard;
  }
}

var mastercard = html(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  <svg\n    class=\"card-icon\"\n    xmlns=\"http://www.w3.org/2000/svg\"\n    viewBox=\"0 0 576 512\"\n  >\n    <path\n      d=\"M482.9 410.3c0 6.8-4.6 11.7-11.2 11.7-6.8 0-11.2-5.2-11.2-11.7 0-6.5 4.4-11.7 11.2-11.7 6.6 0 11.2 5.2 11.2 11.7zm-310.8-11.7c-7.1 0-11.2 5.2-11.2 11.7 0 6.5 4.1 11.7 11.2 11.7 6.5 0 10.9-4.9 10.9-11.7-.1-6.5-4.4-11.7-10.9-11.7zm117.5-.3c-5.4 0-8.7 3.5-9.5 8.7h19.1c-.9-5.7-4.4-8.7-9.6-8.7zm107.8.3c-6.8 0-10.9 5.2-10.9 11.7 0 6.5 4.1 11.7 10.9 11.7 6.8 0 11.2-4.9 11.2-11.7 0-6.5-4.4-11.7-11.2-11.7zm105.9 26.1c0 .3.3.5.3 1.1 0 .3-.3.5-.3 1.1-.3.3-.3.5-.5.8-.3.3-.5.5-1.1.5-.3.3-.5.3-1.1.3-.3 0-.5 0-1.1-.3-.3 0-.5-.3-.8-.5-.3-.3-.5-.5-.5-.8-.3-.5-.3-.8-.3-1.1 0-.5 0-.8.3-1.1 0-.5.3-.8.5-1.1.3-.3.5-.3.8-.5.5-.3.8-.3 1.1-.3.5 0 .8 0 1.1.3.5.3.8.3 1.1.5s.2.6.5 1.1zm-2.2 1.4c.5 0 .5-.3.8-.3.3-.3.3-.5.3-.8 0-.3 0-.5-.3-.8-.3 0-.5-.3-1.1-.3h-1.6v3.5h.8V426h.3l1.1 1.4h.8l-1.1-1.3zM576 81v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V81c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM64 220.6c0 76.5 62.1 138.5 138.5 138.5 27.2 0 53.9-8.2 76.5-23.1-72.9-59.3-72.4-171.2 0-230.5-22.6-15-49.3-23.1-76.5-23.1-76.4-.1-138.5 62-138.5 138.2zm224 108.8c70.5-55 70.2-162.2 0-217.5-70.2 55.3-70.5 162.6 0 217.5zm-142.3 76.3c0-8.7-5.7-14.4-14.7-14.7-4.6 0-9.5 1.4-12.8 6.5-2.4-4.1-6.5-6.5-12.2-6.5-3.8 0-7.6 1.4-10.6 5.4V392h-8.2v36.7h8.2c0-18.9-2.5-30.2 9-30.2 10.2 0 8.2 10.2 8.2 30.2h7.9c0-18.3-2.5-30.2 9-30.2 10.2 0 8.2 10 8.2 30.2h8.2v-23zm44.9-13.7h-7.9v4.4c-2.7-3.3-6.5-5.4-11.7-5.4-10.3 0-18.2 8.2-18.2 19.3 0 11.2 7.9 19.3 18.2 19.3 5.2 0 9-1.9 11.7-5.4v4.6h7.9V392zm40.5 25.6c0-15-22.9-8.2-22.9-15.2 0-5.7 11.9-4.8 18.5-1.1l3.3-6.5c-9.4-6.1-30.2-6-30.2 8.2 0 14.3 22.9 8.3 22.9 15 0 6.3-13.5 5.8-20.7.8l-3.5 6.3c11.2 7.6 32.6 6 32.6-7.5zm35.4 9.3l-2.2-6.8c-3.8 2.1-12.2 4.4-12.2-4.1v-16.6h13.1V392h-13.1v-11.2h-8.2V392h-7.6v7.3h7.6V416c0 17.6 17.3 14.4 22.6 10.9zm13.3-13.4h27.5c0-16.2-7.4-22.6-17.4-22.6-10.6 0-18.2 7.9-18.2 19.3 0 20.5 22.6 23.9 33.8 14.2l-3.8-6c-7.8 6.4-19.6 5.8-21.9-4.9zm59.1-21.5c-4.6-2-11.6-1.8-15.2 4.4V392h-8.2v36.7h8.2V408c0-11.6 9.5-10.1 12.8-8.4l2.4-7.6zm10.6 18.3c0-11.4 11.6-15.1 20.7-8.4l3.8-6.5c-11.6-9.1-32.7-4.1-32.7 15 0 19.8 22.4 23.8 32.7 15l-3.8-6.5c-9.2 6.5-20.7 2.6-20.7-8.6zm66.7-18.3H408v4.4c-8.3-11-29.9-4.8-29.9 13.9 0 19.2 22.4 24.7 29.9 13.9v4.6h8.2V392zm33.7 0c-2.4-1.2-11-2.9-15.2 4.4V392h-7.9v36.7h7.9V408c0-11 9-10.3 12.8-8.4l2.4-7.6zm40.3-14.9h-7.9v19.3c-8.2-10.9-29.9-5.1-29.9 13.9 0 19.4 22.5 24.6 29.9 13.9v4.6h7.9v-51.7zm7.6-75.1v4.6h.8V302h1.9v-.8h-4.6v.8h1.9zm6.6 123.8c0-.5 0-1.1-.3-1.6-.3-.3-.5-.8-.8-1.1-.3-.3-.8-.5-1.1-.8-.5 0-1.1-.3-1.6-.3-.3 0-.8.3-1.4.3-.5.3-.8.5-1.1.8-.5.3-.8.8-.8 1.1-.3.5-.3 1.1-.3 1.6 0 .3 0 .8.3 1.4 0 .3.3.8.8 1.1.3.3.5.5 1.1.8.5.3 1.1.3 1.4.3.5 0 1.1 0 1.6-.3.3-.3.8-.5 1.1-.8.3-.3.5-.8.8-1.1.3-.6.3-1.1.3-1.4zm3.2-124.7h-1.4l-1.6 3.5-1.6-3.5h-1.4v5.4h.8v-4.1l1.6 3.5h1.1l1.4-3.5v4.1h1.1v-5.4zm4.4-80.5c0-76.2-62.1-138.3-138.5-138.3-27.2 0-53.9 8.2-76.5 23.1 72.1 59.3 73.2 171.5 0 230.5 22.6 15 49.5 23.1 76.5 23.1 76.4.1 138.5-61.9 138.5-138.4z\"\n    />\n  </svg>\n"])));
var amex = html(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  <svg\n    class=\"card-icon\"\n    xmlns=\"http://www.w3.org/2000/svg\"\n    viewBox=\"0 0 576 512\"\n  >\n    <path\n      d=\"M48 480C21.49 480 0 458.5 0 432V80C0 53.49 21.49 32 48 32H528C554.5 32 576 53.49 576 80V82.43H500.5L483.5 130L466.6 82.43H369.4V145.6L341.3 82.43H262.7L181 267.1H246.8V430.9H450.5L482.4 395.8L514.3 430.9H576V432C576 458.5 554.5 480 528 480H48zM482.6 364L440.4 410.3H390.5L458 338.6L390.5 266.1H441.9L483.4 312.8L525.4 266.1H576L508 338.2L576 410.3H524.6L482.6 364zM576 296.9V380.2L536.7 338.3L576 296.9zM307.6 377.1H390.6V410.3H268.6V267.1H390.6V300.2H307.6V322.6H388.5V354.9H307.6V377.2V377.1zM537.3 145.7L500.4 246.3H466L429.2 146V246.3H390.5V103H451.7L483.6 192.3L515.8 103H576V246.3H537.3V145.7zM334.5 217.6H268.6L256.7 246.3H213.7L276.1 103H327.3L390.6 246.3H346.5L334.5 217.6zM301.5 138.5L282 185.4H320.9L301.5 138.5z\"\n    />\n  </svg>\n"])));
var visa = html(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  <svg \n    class=\"card-icon \n    xmlns=\"http://www.w3.org/2000/svg\" \n    viewBox=\"0 0 576 512\"\n  >\n    <path\n      d=\"M470.1 231.3s7.6 37.2 9.3 45H446c3.3-8.9 16-43.5 16-43.5-.2.3 3.3-9.1 5.3-14.9l2.8 13.4zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM152.5 331.2L215.7 176h-42.5l-39.3 106-4.3-21.5-14-71.4c-2.3-9.9-9.4-12.7-18.2-13.1H32.7l-.7 3.1c15.8 4 29.9 9.8 42.2 17.1l35.8 135h42.5zm94.4.2L272.1 176h-40.2l-25.1 155.4h40.1zm139.9-50.8c.2-17.7-10.6-31.2-33.7-42.3-14.1-7.1-22.7-11.9-22.7-19.2.2-6.6 7.3-13.4 23.1-13.4 13.1-.3 22.7 2.8 29.9 5.9l3.6 1.7 5.5-33.6c-7.9-3.1-20.5-6.6-36-6.6-39.7 0-67.6 21.2-67.8 51.4-.3 22.3 20 34.7 35.2 42.2 15.5 7.6 20.8 12.6 20.8 19.3-.2 10.4-12.6 15.2-24.1 15.2-16 0-24.6-2.5-37.7-8.3l-5.3-2.5-5.6 34.9c9.4 4.3 26.8 8.1 44.8 8.3 42.2.1 69.7-20.8 70-53zM528 331.4L495.6 176h-31.1c-9.6 0-16.9 2.8-21 12.9l-59.7 142.5H426s6.9-19.2 8.4-23.3H486c1.2 5.5 4.8 23.3 4.8 23.3H528z\"\n    />\n  </svg>\n"])));
var defaultCard = html(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  <svg\n    class=\"card-icon\"\n    xmlns=\"http://www.w3.org/2000/svg\"\n    viewBox=\"0 0 576 512\"\n  >\n    <path\n      d=\"M64 32C28.7 32 0 60.7 0 96v32H576V96c0-35.3-28.7-64-64-64H64zM576 224H0V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V224zM112 352h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z\"\n    />\n  </svg>\n"])));

var PaymentElement = /*#__PURE__*/function (_LitElement) {
  _inherits(PaymentElement, _LitElement);

  var _super = _createSuper(PaymentElement);

  function PaymentElement() {
    var _this;

    _classCallCheck(this, PaymentElement);

    _this = _super.apply(this, arguments);
    _this.loading = true;
    _this.loadingCardElement = true;
    _this.displayExistingPaymentMethod = false;
    return _this;
  }

  _createClass(PaymentElement, [{
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var _a;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _get(_getPrototypeOf(PaymentElement.prototype), "connectedCallback", this).call(this);

                (_a = this.shadowRoot) == null ? void 0 : _a.addEventListener("cardFormReady", function () {
                  _this2.loadingCardElement = false;
                });
                _context.next = 4;
                return this.loadPaymentMethods();

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }

      return connectedCallback;
    }()
  }, {
    key: "loadPaymentMethods",
    value: function () {
      var _loadPaymentMethods = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var customerId, res, jsonData;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.loading = true;

                if (!(this.customerClientSecret === void 0)) {
                  _context2.next = 5;
                  break;
                }

                this.displayExistingPaymentMethod = false;
                this.loading = false;
                return _context2.abrupt("return");

              case 5:
                customerId = parseJwt(this.customerClientSecret).customer_id;
                _context2.next = 8;
                return fetch("".concat(apiHost, "/v1/customers/").concat(customerId, "/payment-method"), {
                  headers: {
                    "Authorization": "Bearer ".concat(this.customerClientSecret)
                  }
                });

              case 8:
                res = _context2.sent;
                this.loading = false;

                if (!(res.status == 200)) {
                  _context2.next = 19;
                  break;
                }

                _context2.next = 13;
                return res.json();

              case 13:
                jsonData = _context2.sent;
                this.paymentMethod = jsonData.card;
                this.displayExistingPaymentMethod = true;
                this.loadingCardElement = false;
                _context2.next = 20;
                break;

              case 19:
                this.displayExistingPaymentMethod = false;

              case 20:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function loadPaymentMethods() {
        return _loadPaymentMethods.apply(this, arguments);
      }

      return loadPaymentMethods;
    }()
  }, {
    key: "validate",
    value: function () {
      var _validate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _a, errors, cardForm, res, isFormValid, response;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                errors = [];
                cardForm = (_a = this.shadowRoot) == null ? void 0 : _a.querySelector("justifi-card-form");
                _context3.next = 4;
                return cardForm == null ? void 0 : cardForm.validate();

              case 4:
                res = _context3.sent;
                isFormValid = res ? res.isValid : false;

                if (!isFormValid) {
                  errors.push("invalid_card_data");
                }

                response = {
                  isValid: isFormValid,
                  errors: errors
                };
                return _context3.abrupt("return", response);

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function validate() {
        return _validate.apply(this, arguments);
      }

      return validate;
    }()
  }, {
    key: "tokenize",
    value: function () {
      var _tokenize = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(paymentMethodData) {
        var _this3 = this;

        var _a, isValid, requestClientId, cardForm, res;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(this.displayExistingPaymentMethod && this.paymentMethod)) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return", new Promise(function (resolve) {
                  return resolve(_this3.paymentMethod.token);
                }));

              case 2:
                _context4.next = 4;
                return this.validate();

              case 4:
                isValid = _context4.sent.isValid;

                if (isValid) {
                  _context4.next = 7;
                  break;
                }

                throw new Error("Tokenization failed due to validation errors.");

              case 7:
                if (!(!paymentMethodData.address_postal_code || paymentMethodData.address_postal_code === "")) {
                  _context4.next = 9;
                  break;
                }

                throw new Error("Tokenizezation failed due to missing billing zip code.");

              case 9:
                requestClientId = this.clientId.startsWith("test") ? paymentProcessorClientId.test : paymentProcessorClientId.live;
                cardForm = (_a = this.shadowRoot) == null ? void 0 : _a.querySelector("justifi-card-form");
                _context4.next = 13;
                return cardForm == null ? void 0 : cardForm.tokenize(requestClientId, paymentMethodData);

              case 13:
                res = _context4.sent;
                return _context4.abrupt("return", res == null ? void 0 : res.id);

              case 15:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function tokenize(_x) {
        return _tokenize.apply(this, arguments);
      }

      return tokenize;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      return html(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n      <div id=\"payment-element-wrapper\" class=", ">\n        ", "\n        ", "\n      </div>\n    "])), classMap({
        "expand-for-iframe": !this.displayExistingPaymentMethod
      }), when(this.loading || this.loadingCardElement, function () {
        return html(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n          <loading-animation></loading-animation>\n        "])));
      }), when(this.displayExistingPaymentMethod, function () {
        return html(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n          <section id=\"currently-saved-card\">\n            <div>", "</div>\n            <div id=\"card-number\" class=\"", "\">\n              ", "\n            </div>\n            <div>\n              ", "/", "\n            </div>\n            <button\n              id=\"edit-payment-card\"\n              @click=", "\n            >\n              edit\n            </button>\n          </section>\n        "])), cardSvg(_this4.paymentMethod.brand), _this4.paymentMethod.brand, _this4.paymentMethod.acct_last_four, _this4.paymentMethod.month, _this4.paymentMethod.year, function () {
          return _this4.displayExistingPaymentMethod = false;
        });
      }, function () {
        return html(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n          <justifi-card-form style=", "></justifi-card-form>\n        "])), !_this4.loading && !_this4.displayExistingPaymentMethod ? "display: block;" : "display: none;");
      }));
    }
  }]);

  return PaymentElement;
}(LitElement);

PaymentElement.styles = css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n\n    #payment-element-wrapper {\n      display: flex;\n      flex: 1;\n      justify-content: center;\n      width: 100%;\n      position: relative;\n      min-height: 40px;\n      margin-bottom: 10px;\n      margin-top: 10px;\n    }\n\n    .expand-for-iframe {\n      min-height: 140px !important;\n    }\n\n    #currently-saved-card {\n      display: flex;\n      gap: 15px;\n  \n      justify-content: center;\n      align-items: center;\n  \n      padding: 6px 10px;\n      margin-bottom: 10px;\n      border: 1px solid var(--default-vi-border-color);\n      border-radius: var(--default-vi-border-radius);\n    }\n\n    #currently-saved-card div {\n      display: flex;\n      align-items: center;\n    }\n  \n    .card-icon {\n      width: 30px;\n    }\n  \n    #card-number {\n      font-weight: bold;\n    }\n  \n    .mastercard,\n    .visa:before {\n      content: \"**** **** **** \";\n    }\n  \n    .amex:before {\n      content: \"**** ****** *\";\n    }\n  \n    button {\n      color: var(--default-vi-primary-color);\n      text-decoration: underline;\n      font-size: 0.9rem;\n      background: none;\n      border: none;\n      cursor: pointer;\n    }\n  \n    button:hover {\n      text-decoration: none;\n    }\n\n    loading-animation {\n      position: absolute;\n      inset: 0;\n    }\n\n    justifi-card-form {\n      width: 100%;\n    }\n  "])));

__decorateClass([property()], PaymentElement.prototype, "customerClientSecret", 2);

__decorateClass([property()], PaymentElement.prototype, "clientId", 2);

__decorateClass([state()], PaymentElement.prototype, "loading", 2);

__decorateClass([state()], PaymentElement.prototype, "loadingCardElement", 2);

__decorateClass([state()], PaymentElement.prototype, "displayExistingPaymentMethod", 2);

__decorateClass([state()], PaymentElement.prototype, "paymentMethod", 2);

PaymentElement = __decorateClass([customElement("payment-element")], PaymentElement);
export { PaymentElement, cardSvg };